import api from "@/api";

export async function getFirmi() {
  const res = await api.get("/get/firmi");
  return res.data;
}